// src/components/ui/sections/CompanyInformationSection/CompanyInformationSectionShadcn.jsx
import React from 'react';
import { Save } from 'lucide-react';

// shadcn components
import { Button } from '../../button';
import { Input } from '../../input';
import { Label } from '../../label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../select';

import { cn } from '../../../../utils/cn';

const CompanyInformationSectionShadcn = ({
  companyForm,
  setCompanyForm,
  handleCompanySubmit,
  savingSettings,
  hasChanges,
  stateOptions,
  className = ''
}) => {
  return (
    <div className={cn('h-full flex flex-col', className)}>
      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto p-6">
        <form onSubmit={handleCompanySubmit} className="space-y-6">
          {/* Name and Phone Row */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <Label htmlFor="company_name">
                Company Name <span className="text-red-400">*</span>
              </Label>
              <Input
                id="company_name"
                type="text"
                value={companyForm.company_name}
                onChange={(e) => setCompanyForm(prev => ({...prev, company_name: e.target.value}))}
                placeholder="Enter your company name"
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="company_phone">
                Phone Number <span className="text-red-400">*</span>
              </Label>
              <Input
                id="company_phone"
                type="tel"
                value={companyForm.company_phone}
                onChange={(e) => setCompanyForm(prev => ({...prev, company_phone: e.target.value}))}
                placeholder="(555) 123-4567"
                required
              />
            </div>
          </div>

          {/* Address */}
          <div className="space-y-2">
            <Label htmlFor="company_address">Address</Label>
            <Input
              id="company_address"
              type="text"
              value={companyForm.company_address}
              onChange={(e) => setCompanyForm(prev => ({...prev, company_address: e.target.value}))}
              placeholder="123 Main Street"
            />
          </div>

          {/* City, State, ZIP Row */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="col-span-2 space-y-2">
              <Label htmlFor="company_city">City</Label>
              <Input
                id="company_city"
                type="text"
                value={companyForm.company_city}
                onChange={(e) => setCompanyForm(prev => ({...prev, company_city: e.target.value}))}
                placeholder="Dallas"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="company_state">State</Label>
              <Select
                value={companyForm.company_state}
                onValueChange={(value) => setCompanyForm(prev => ({...prev, company_state: value}))}
              >
                <SelectTrigger>
                  <SelectValue placeholder="State" />
                </SelectTrigger>
                <SelectContent>
                  {stateOptions.map(option => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label htmlFor="company_zip">ZIP Code</Label>
              <Input
                id="company_zip"
                type="text"
                value={companyForm.company_zip}
                onChange={(e) => setCompanyForm(prev => ({...prev, company_zip: e.target.value}))}
                placeholder="75201"
              />
            </div>
          </div>

          {/* Email and Website Row */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <Label htmlFor="company_email">Email</Label>
              <Input
                id="company_email"
                type="email"
                value={companyForm.company_email}
                onChange={(e) => setCompanyForm(prev => ({...prev, company_email: e.target.value}))}
                placeholder="business@company.com"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="company_website">Website</Label>
              <Input
                id="company_website"
                type="url"
                value={companyForm.company_website}
                onChange={(e) => setCompanyForm(prev => ({...prev, company_website: e.target.value}))}
                placeholder="https://yourcompany.com"
              />
            </div>
          </div>
        </form>
      </div>

      {/* Fixed Footer with Save Button */}
      <div className="flex-shrink-0 p-6 border-t">
        <div className="flex items-center justify-end">
          <Button
            onClick={handleCompanySubmit}
            disabled={!hasChanges || savingSettings}
            size="lg"
            className="shadow-lg"
          >
            {savingSettings ? (
              <>
                <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin mr-2" />
                Saving...
              </>
            ) : (
              <>
                <Save className="w-4 h-4 mr-2" />
                Save Settings
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CompanyInformationSectionShadcn;